<template>
  <div class="w-12/12 mx-auto flex-row flex-wrap justify-between font-costea px-12 py-4">

    <div class="flex flex-row justify-between pt-3 pb-2 mb-6 mt-2 flex-wrap">
      <div class="flex flex-row justify-center items-center">
        <button @click="getBack()"
          class="flex flex-row justify-center items-center mr-6 bg-costeaBtn2 hover:bg-costeaBtn2Hover px-2 py-2 rounded-md text-costeaPrimary">
          <i class="ri-arrow-left-s-line text-2xl text-costeaPrimary"></i>
          Atras
        </button>
        <h1 class="font-costea text-h24 font-medium text-costeaBlack mb-4 md:mb-0">
          {{ producto.nombre }}
        </h1>
      </div>
      <div v-if="isLoading" class="flex flex-row items-center">
        <div class="ml-4">
          <!-- <div class="h-4 w-40 bg-gray-200 rounded-full mt-2 animate-pulse"></div> -->
          <div class="h-4 w-40 bg-gray-200 rounded-full mt-2 animate-pulse"></div>
        </div>
        <div class="ml-4">
          <!-- <div class="h-4 w-20 bg-gray-200 rounded-full mt-2 animate-pulse"></div> -->
          <div class="h-4 w-20 bg-gray-200 rounded-full mt-2 animate-pulse"></div>
        </div>
        <div class="ml-4">
          <!-- <div class="h-4 w-20 bg-gray-200 rounded-full mt-2 animate-pulse"></div> -->
          <div class="h-4 w-20 bg-gray-200 rounded-full mt-2 animate-pulse"></div>
        </div>
      </div>
      <div class="flex flex-row items-center" v-else>
        <div class="flex flex-wrap bg-white p-2 rounded-md shadow-md gap-2"
          v-show="this.rol_usuario === '1' || this.rol_usuario === '2'">
          <!-- Bloque CT -->
          <div class="flex items-center p-2">
            <span class="w-3 h-3 rounded-full bg-yellow-500 inline-block mr-2"></span>
            <p class="text-gray-800 font-medium">CT: $ {{ !isNaN(producto.costo_total) ?
              interNumberFormat(producto.costo_total) : 0 }}</p>
          </div>

          <!-- Bloque PVS -->
          <div class="flex items-center p-2">
            <span class="w-3 h-3 rounded-full bg-blue-500 inline-block mr-2"></span>
            <p class="text-gray-800 font-medium">PV: $ {{ !isNaN(producto.precio_venta_actual) ?
              interNumberFormat(this.producto.precio_venta_actual) : 0 }}</p>
          </div>

          <!-- Bloque UB -->
          <div class="flex items-center p-2">
            <span class="w-3 h-3 rounded-full bg-costeaGreen inline-block mr-2"></span>
            <p class="text-gray-800 font-medium">UB: $ {{ !isNaN(this.producto.costo_total) &&
              this.producto.precio_venta_actual != 0 ?
              interNumberFormat(this.producto.precio_venta_actual - this.producto.costo_total) : 0 }}</p>
          </div>

          <!-- Bloque MC -->
          <div class="flex items-center p-2">
            <span class="w-3 h-3 rounded-full bg-purple-500 inline-block mr-2"></span>
            <p class="text-gray-800 font-medium">MC: {{ !isNaN(this.producto.costo_total) &&
              this.producto.precio_venta_actual != 0 ?
              ((this.producto.precio_venta_actual - this.producto.costo_total) / this.producto.precio_venta_actual *
              100).toFixed(2) : 0 }}%</p>
          </div>
        </div>
      </div>
    </div>

    <div class="flex justify-between flex-wrap lg:flex-nowrap relative">
      <div class="columna flex items-start w-12/12 mr-0 lg:mr-3 lg:w-3/12">
        <div class="rounded-md overflow-hidden flex flex-col items-center justify-center bg-white mb-2">


          <div v-if="!this.loading" class=" bg-costeaGray relative w-full h-40 md:h-60 lg:h-40 "
            :style="`background-repeat: no-repeat; background-size: contain; background-position:center center; ${showImage(this.producto.picture)}`">
            <span @click="showModalEdit()"
              class="flex flex-row absolute bg-costeaPrimary text-white w-auto right-2 -bottom-5 text-t14 p-2 rounded-full cursor-pointer">
              <i class="ri-edit-line mr-1 ml-1 text-xl"></i>
            </span>
          </div>
          <div v-else class="skeleton bg-costeaGray relative w-96 h-40 md:h-60 lg:h-40 "> asdasds</div>
          <div class="text-t14 leading-5 text-costeaGray px-1 py-3 border-b-2 border-costeaContainer w-11/12">
            <p class="text-costeaGray font-normal text-t14 my-2">Referencia: <span
                class="text-costeaBlack font-medium text-t16">{{ this.producto.referencia }}</span></p>
            <div class="flex items-center mb-3">
              <div><i class="ri-barcode-line ml-1 text-xl mr-2"></i></div>
              <div>
                <p class="text-t12 text-costeaGray">Codigo de barras <br><span
                    class="text-costeaBlack font-medium text-t14">{{ this.producto.codigo_barras }}</span></p>
              </div>
            </div>
            <div class="flex items-center mb-3">
              <div><i class="ri-stack-line ml-1 text-xl mr-2"></i></div>
              <div>
                <p class="text-t12 text-costeaGray">Categoría <br><span class="text-costeaBlack font-medium text-t14">{{
                    this.category.name
                    }}</span></p>
              </div>
            </div>
            <div class="flex items-center mb-3">
              <div><i class="ri-stock-line ml-1 text-xl mr-2"></i></div>
              <div>
                <p class="text-t12 text-costeaGray" v-if="this.producto.componentes">Componentes <br><span
                    class="text-costeaBlack font-medium text-t14">{{ this.producto.componentes.length }}</span></p>

              </div>
            </div>
            <div class="flex items-center mb-3">
              <div>
                <p class="text-costeaGray font-medium text-xl ml-3 mr-2">$</p>
              </div>
              <div>
                <p class="text-t12 text-costeaGray">Precio de venta actual (COP) <br><span
                    class="text-costeaBlack font-medium text-t14">{{
                    interNumberFormat(this.producto.precio_venta_actual)
                    }}</span>
                </p>
              </div>
            </div>

          </div>
          <div :class="{ 'color-transparent': rol_usuario === '3' }"
            class="flex flex-wrap flex-row w-full justify-between px-4 py-3 text-t14 text-costeaGray">
            <div class="flex w-6/12">
              <div class="flex items-center mb-3">
                <div>
                  <p class="text-t12">Costo de materia prima<br><span class="text-costeaGray font-medium text-t16">$
                      {{ interNumberFormat(producto.costo_materia_prima) }}</span></p>
                </div>
              </div>
            </div>
            <div class="flex w-5/12 justify-center">
              <div class="flex items-center justify-end text-center mb-3">
                <div>
                  <p class="text-t12">Porcentaje vs CT<br><span class="text-costeaGray font-medium text-t16">{{
                      producto.costo_total ? ((producto.costo_materia_prima /
                      producto.costo_total) * 100).toFixed(2) : 0
                      }} %</span></p>
                </div>
              </div>
            </div>
            <div class="flex w-7/12">
              <div class="flex items-center mb-3">
                <div>
                  <p class="text-t12">Costo mano de obra<br>
                    <span class="text-costeaGray font-medium text-t16">
                      ${{ producto.costo_mano_obra ? interNumberFormat(producto.costo_mano_obra) : '0.00' }}
                    </span>
                  </p>

                </div>
              </div>
            </div>
            <div class="flex justify-center w-5/12">
              <div class="flex items-center justify-center text-center mb-3">
                <div class="w-6/6">
                  <p class="text-costeaGray font-medium text-t16 mt-5">{{ producto.costo_total ?
                    (((producto.costo_mano_obra !==
                    null ? producto.costo_mano_obra : producto.costo_mano_obra) /
                    producto.costo_total) * 100).toFixed(2) : 0
                    }} %</p>
                </div>
              </div>
            </div>
            <div class="flex w-7/12">
              <div class="flex items-center mb-3">
                <div>
                  <p class="text-t12">CIF<br><span class="text-costeaGray font-medium text-t16">$ {{
                      producto.costo_cif ?
                      interNumberFormat(producto.costo_cif) : 0.00
                      }}</span></p>
                </div>
              </div>
            </div>
            <div class="flex justify-center w-5/12">
              <div class="flex items-center justify-center text-center mb-3">
                <div class="w-6/6">
                  <p class="text-costeaGray font-medium text-t16  mt-5"> {{ producto.costo_total ? ((producto.costo_cif
                    /
                    producto.costo_total) * 100).toFixed(2) : 0
                    }} %</p>
                </div>
              </div>
            </div>
            <div class="flex w-full">
              <div class="flex items-center mb-3">
                <button class="flex items-center justify-center rounded-full bg-costeaYellow w-7 h-7">
                  <span class="text-white text-t16">$</span>
                </button>
                <p class="text-t16 ml-3 font-medium text-costeaBlack">Costo total: $ {{
                  producto.costo_total ?
                  interNumberFormat(producto.costo_total) : 0.00
                  }}</p>

              </div>
            </div>
            <div class="flex w-full justify-end">
              <div class="flex items-end mb-3 ">
                <button @click="sincronizarCostoTotal()"
                  class="flex bg-costeaBtn2 hover:bg-costeaBtn2Hover cursor-pointer items-center px-4 py-2 text-costeaPrimary text-t12 rounded-md">
                  <span>Sincronizar costo total</span>
                  <i class="ri-refresh-line ml-2 text-t14"></i>
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="detalle flex w-full bg-white rounded-md lg:w-9/12 px-2 mt-4 sm:mt-0 overflow-x-auto">
        <div
          class="flex w-full mx-auto flex-wrap items-start justify-start content-start bg-white rounded-md pt-8 pb-20 lg:w-11/12">
          <div class="flex justify-between items-start font-costea text-t16 w-full">
            <div class="w-full sm:w-full md:w-full lg:w-full overflow-x-auto flex">
              <button v-for="tab in this.tabs" :key="tab.index" @click="selected = tab.component"
                :class="[' text-sm flex text-left px-4 h-auto border-b-2 cursor-pointer border-costeaBtn2Hover text-costeaBtn2Hover outline-none w-3/12 pb-12 md:pb-0', { active: selected == tab.component }]">
                <span class="flex items-center pb-2"><i class='mr-1' :class="[tab.icon]"></i>{{ tab.txt }}</span>
              </button>
            </div>
          </div>
          <div class="flex items-center w-full">
            <transition name="fade" mode="out-in">
              <component :is="selected" @reloadData='reloadData' class="h-full" v-bind:dataCategory="this.category"
                v-bind:dataProducto="this.producto" v-bind:manoObra="this.producto.costo_mano_obra"
                v-bind:cif="this.producto.costo_cif" v-bind:dataComponentes="this.componentes"
                v-bind:dataComponentesProducto="this.producto.componentes" v-bind:costoTotal="this.calcCostoTotal"
                v-bind:precioVentaActual="this.producto.precio_venta_actual" v-bind:calcCostoTotal="calcCostoTotal" />
            </transition>
          </div>
        </div>
      </div>
    </div>

    <div class="grid grid-cols-12 gap-2 pb-10">
      <div class="col-start-1 col-end-13 p-2 rounded-md" v-if="existencia">
        <div class="h-10 flex flex-row items-center font-costea text-t14">
          <input type="checkbox" class="w-4 h-4 rounded-sm border-2 mr-2">
          <span class="px-2 cursor-pointer text-costeaDarkGray">Seleccionar todos</span>
        </div>
      </div>

      <div class="col-start-1 col-end-13 grid grid-cols-1 gap-6 md:grid-cols-3 xl:grid-cols-4 sm:grid-cols-2"
        v-if="existencia">

        <div v-for="num in this.nums" :key="num"
          class="rounded-md overflow-hidden flex flex-col items-center justify-center bg-white">
          <div class="bg-costeaGray w-full h-36">
            <img class="w-full h-full mr-2 " src="@/assets/img/cuerda.jpg" alt="">
            <span
              class="flex flex-row absolute bg-costeaDarkYellow text-white w-auto right-2 top-2 text-t14 p-2 rounded-md">
              <i class="ri-time-line mr-2"></i>
              <span>$ 8,460 <span>{{ num }}</span> </span>
            </span>
          </div>
          <div class="text-t12 leading-5 text-costeaGray px-5 py-3 border-b-2 border-costeaContainer w-full">
            <h4 class="text-costeaBlack font-medium text-t14 pb-2">Correa</h4>
            <p class="text-costeaBlack font-medium">Referencia: <span
                class="text-costeaBlack font-medium">31-42B-2</span>
            </p>
            <p>Unidad de medida: <span class="text-costeaBlack font-medium">cm</span></p>
            <p>Tipo de materia prima: <span class="text-costeaBlack font-medium">Importado</span></p>
            <p>Costo unitario: <span class="text-costeaBlack font-medium">$1,232.76</span></p>
          </div>
          <div class="flex flex-row w-full justify-end px-5 py-3 text-t14">
            <button
              class="flex items-center justify-center rounded-full text-costeaPrimary bg-costeaPrimaryDisabled hover:text-costeaBtn2 hover:bg-costeaPrimary w-7 h-7 mr-2">
              <i class="ri-pencil-fill"></i>
            </button>
            <button
              class="flex items-center justify-center rounded-full bg-costeaSalmonDisabled text-costeaDarkSalmon hover:bg-costeaSalmon hover:text-costeaSalmonDisabled w-7 h-7">
              <i class="ri-delete-bin-5-fill"></i>
            </button>
          </div>
        </div>

      </div>



    </div>



    <transition name="page">
      <component :nombreOld='editName' :id='editId' :referenciaOld='editReferencia'
        :codigobarrasOld='editCodigodeBarras' :categoriaOld='editCategoria' :precioventaOld='editPrecioVenta'
        :editComponents='editComponents' :editcostomanoobra='editcostomanoobra' :admongastos='admongastos'
        :cifcostos='cifcostos' :modirectas='modirectas' v-show="this.modalEdit" :is="this.editProduct"
        @closeModalEdit="handleEditCloseModal" @reloadData='reloadData' />
    </transition>


  </div>
</template>

<script>
import MateriaPrima from '@/components/productos/MateriaPrima.vue'
import CostoCIF from '@/components/productos/CostoCIF.vue'
import GastosAdmon from '@/components/productos/GastosAdmon.vue'
import EditProducts from '@/components/productos/EditProducts.vue'
import ManoDeObra from '@/components/productos/ManoDeObra.vue'
import ChangePass from '@/components/profile/ChangePass.vue'
import axios from 'axios'
import { mapState } from 'vuex'

export default {
  name: "ProductosDetalle",
  components: {
    MateriaPrima,
    ManoDeObra,
    CostoCIF,
    ChangePass,
    EditProducts,
    GastosAdmon
  },
  data() {
    return {
      loading: true,
      editName: '',
      editId: '',
      editReferencia: '',
      editCodigodeBarras: '',
      editCategoria: '',
      editPrecioVenta: '',
      editComponents: '',
      editcostomanoobra: '',
      admongastos: '',
      cifcostos: '',
      modirectas: '',
      rol_usuario: localStorage.getItem('rol_usuario'),
      nums: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      ventana: false,
      modalEdit: false,
      cop: false,
      usd: false,
      mensaje: true,
      accion: 'Null',
      existencia: false,
      existenciab: true,
      sin_existencia: true,
      con_existencia: false,
      detalle: true,
      tabs: [
        {
          id: 1,
          component: "MateriaPrima",
          txt: "Materia Prima",
          css: "border-costeaPrimary text-costeaPrimary font-medium",
          icon: "ri-shopping-bag-line"
        },
        {
          id: 2,
          component: "ManoDeObra",
          txt: "Mano de Obra",
          css: "border-costeaPrimary text-costeaPrimary font-medium",
          icon: "ri-user-2-line"
        },
        {
          id: 3,
          component: "CostoCIF",
          txt: "Costo CIF",
          css: "border-costeaPrimary text-costeaPrimary font-medium",
          icon: "ri-price-tag-3-line"
        },
        {
          id: 4,
          component: "GastosAdmon",
          txt: "Gastos Admon",
          css:"border-costeaPrimary text-costeaPrimary font-medium",
          icon: "ri-bill-line"
        }
      ],
      selected: "MateriaPrima",
      producto: {},
      componentesproducto: [],
      componentesPrecio: [],
      modirectasProducto: [],
      cifProducto: [],
      productoComp: [],
      componentes: [],
      category: {},
      secretWord: localStorage.getItem('secret-word'),
      productoManoObra: [],
      manoObraDirecta: [],
      costosCif: [],
      tiempoStandarMOD: [],
      costos: {
        materiaPrima: 0,
        manoObra: 0,
        cif: 0,
        total: 0
      },
      isLoading: true
    };
  },
  computed: {
    ...mapState(['costea']),
    editProduct() {
      return this.modalEdit ? 'EditProducts' : '';
    }
  },
  watch: {
    componentesPrecio: {
      handler() {
        this.costos.materiaPrima = this.calcMateriaPrima();
        this.calcCostoTotal();
      },
      deep: true
    },
    modirectasProducto: {
      handler() {
        this.costos.manoObra = this.calcManoObra();
        this.calcCostoTotal();
      },
      deep: true
    },
    costosCif: {
      handler() {
        this.costos.cif = this.calcCif();
        this.calcCostoTotal();
      },
      deep: true
    }
  },
  methods: {
    async guardarCostoTotal(ct) {
      const data = {
        id: this.$route.params.id,
        costo_total: ct
      };
      try {
        const response = await axios.put(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}updateCostoTotal/${this.$route.params.id}`, data);
        console.log(data);
        console.log('costo total', response);
      } catch (error) {
        console.log(error);
      }
    },
    getBack() {
      this.$router.push({ name: 'products', query: { paginado: this.$route.query.paginado } });
    },
    interNumberFormat(number) {
      let interNF = new Intl.NumberFormat('es-CO');
      let numberDecimals = parseFloat(number);
      numberDecimals = numberDecimals.toFixed(2);
      return isNaN(number) ? number : interNF.format(numberDecimals);
    },
    showImage(imagen) {
      if (imagen != null) {
        let imageFromServer = this.costea.protocol + this.secretWord + '.backend.costea.com.co/' + imagen;
        return `background-color: #E6E8ED; background-image: url('${imageFromServer}');`;
      } else {
        return `bg-costeaGray; skeleton;`;
      }
    },
    async getProducto() {
      try {
        const respuesta = await axios.get(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}producto-view/${this.$route.params.id}`);
        console.log("Producto", respuesta);
        this.producto = respuesta.data.data;
        this.productoTiempoStandar = respuesta.data.data.tiempo_standar;
        this.productoHorasHombre = respuesta.data.data.horas_hombre;
        this.productoComp = respuesta.data.data.componentes;
        this.productoManoObra = respuesta.data.data.modirectas;
        this.productoCif = respuesta.data.data.cifcostos;
        this.isLoading = false;
        // const res = await axios.get(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}categories-view/${respuesta.data.data.id_category}`);
        this.category = respuesta.data.data.categoria;
        const response = await axios.get(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}componentes`);
        this.componentes = response.data;
        this.filterComponents();
        this.calcMateriaPrima();
        this.calcCostoTotal();
        // const responseMo = await axios.get(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}mod`);
        // this.manoObraDirecta = responseMo.data;
        this.filterMoDirectas();
        // const responseCif = await axios.get(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}cif`);
        // this.costosCif = responseCif.data;
        // this.filterCif();
      } catch (error) {
        console.log(error);
      }
    },
    sincronizarCostoTotal() {
      axios.post(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}componente-updateTotalCoast/${this.producto.referencia}`, { costo_unitario: this.producto.costo_total })
        .then(response => {
          console.log("sincronizarCostoTotal - response", response);
        }).catch(error => console.log(error));
    },
    filterComponents() {
      const componentMap = new Map(this.componentes.map(c => [c.id, c]));
      this.componentesproducto = this.productoComp.map(producto => componentMap.get(producto.componentes_id)).filter(Boolean);
      this.componentesPrecio = this.productoComp.map(producto => {
        const componente = componentMap.get(producto.componentes_id);
        return componente ? { price: componente.tipo_materia_prima === 'Nacional' ? componente.costo_unitario : (componente.costo_unitario * componente.tasa_de_cambio), quantity: producto.cantidadVinculada } : null;
      }).filter(Boolean);
    },
    filterMoDirectas() {
      this.modirectasProducto = this.manoObraDirecta.filter(mo => this.productoManoObra.some(pmo => pmo.mano_obra_directa_id === mo.id));
    },
    // filterCif() {
    //   this.cifProducto = this.costosCif.filter(cif => this.productoCif.some(pc => pc.cif_costo_id === cif.id));
    // },
    reloadData(value) {
      if (value === true) {
        this.getProducto();
        value = false;
      } else {
        console.log('Ocurrio un error');
      }
    },
    handleEditCloseModal(value) {
      this.modalEdit = value;
    },
    showModalEdit() {
      if (this.modalEdit === false) {
        this.modalEdit = true;
        this.editName = this.producto.nombre;
        this.editId = this.producto.id;
        this.editReferencia = this.producto.referencia;
        this.editCodigodeBarras = this.producto.codigo_barras;
        this.editCategoria = this.producto.id_category;
        this.editPrecioVenta = this.producto.precio_venta_actual;
        this.editComponents = JSON.stringify(this.producto.componentes.map(p => p.componentes_id));
        this.editcostomanoobra = this.producto.costo_mano_obra;
        this.admongastos = this.producto.admongastos;
        this.cifcostos = this.producto.cifcostos;
        this.modirectas = this.producto.modirectas;
      } else {
        this.modalEdit = false;
        this.editName = '';
        this.editId = '';
        this.editReferencia = '';
        this.editCodigodeBarras = '';
        this.editCategoria = '';
        this.editPrecioVenta = '';
      }
    },
    calcMateriaPrima() {
      let suma = 0;
      for (let i = 0; i < (this.componentesPrecio.length || 0); i++) {
        suma = suma + (Number(this.componentesPrecio[i].price) * Number(this.componentesPrecio[i].quantity));
      }
      return suma;
    },
    calcManoObra() {
      let manoDeObra = 0
      for (let i = 0; i < this.productoManoObra.length; i++) {
        const element = this.productoManoObra[i];
        if (element.tiempo_standar == 0) {
          manoDeObra += parseInt(element.costo_hora_hombre);
        } else {
          manoDeObra += parseInt(element.costo_hora_hombre) * parseInt(element.tiempo_standar);
        }
      }
      return manoDeObra



    },
    calcCif() {
      let sumaCosto = 0;
      for (let i = 0; i < this.costosCif.length; i++) {
        let costoHora = Number(this.costosCif[i].costo_mensual);
        sumaCosto += costoHora;
      }
      let total = ((sumaCosto / this.producto.horas_hombre) * this.producto.tiempo_standar).toFixed(2);
      return Number(total);
    },
    calcCostoTotal() {
      // this.isLoading = true;
      // console.time('0');
      let ct = parseFloat(this.costos.materiaPrima) + parseFloat(this.producto.costo_mano_obra) + parseFloat(this.costos.cif);
      this.costos.total = ct;
      // console.timeEnd('0');

    }
  },
  mounted() {
    setTimeout(() => {

      console.log(this.loading)
      this.loading = false
      console.log(this.loading)
    }), 4000
    this.getProducto();
    // this.calcManoObra()
  }
};
</script>


<style>
.z-100 {
  z-index: 100;
}

.costeaGreenGradient {
  background: linear-gradient(to left, #1db966, #2ae0af);
}

.costeaOrangeGradient {
  background: linear-gradient(to left, #ffaf14, #ffce81);
}

.costeaBlueGradient {
  background: linear-gradient(to left, #0088f5, #48ccf7);
}

.costeaLightBlueGradient {
  background: linear-gradient(to left, #51c9eb, #56e8da);
}

.costeaMaxWidth {
  max-width: 380px;
}

.color-transparent {
  visibility: hidden;
  max-height: 0vh;
}

.esquina {
  top: 90% !important;
}

.costeaYellowAlertBack {
  background-color: #ffeab3;
}

.costeaYellowAlertText {
  color: #ffc627;
}

.skeleton {
  position: relative;
  width: 100%;
  /* Ancho del skeleton */
  height: auto;
  /* Altura del skeleton */
  overflow: hidden;
  /* Oculta el desbordamiento del pseudo-elemento */
  color: transparent
}

.skeleton::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: transparent;
  background-color: #f2f2f2;
  /* Color de fondo del skeleton */
  animation: skeleton-loading 1s infinite ease-in-out;
  /* Animación del skeleton */
}

@keyframes skeleton-loading {
  0% {
    opacity: 0.7;
    /* Opacidad inicial del skeleton */
  }

  50% {
    opacity: 0.4;
    /* Opacidad intermedia del skeleton */
  }

  100% {
    opacity: 0.7;
    /* Opacidad final del skeleton */
  }
}</style>